export default [
  {
    title: 'Card',
    icon: 'CreditCardIcon',
    route: 'card-detail',
  },
  {
    title: 'Tag',
    icon: 'CircleIcon',
    route: 'tag-detail',
  },
]
